module.exports = __webpack_public_path__ + "assets/pdf/SpeakUp - How To Report.bf202644.pdf";